// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"34596089","671":"e2a48703","686":"225441ba","761":"45fb30e1","893":"f77395d7"}[chunkId] + ".chunk.css";
};